/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ guest: NonNullable<unknown>, host: NonNullable<unknown> }} Friend_Guest_Today_LineInputs */

const fr_friend_guest_today_line = /** @type {(inputs: Friend_Guest_Today_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.guest}, invité(e) par ${i?.host}`)
};

/**

* @param {Friend_Guest_Today_LineInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const friend_guest_today_line = /** @type {((inputs: Friend_Guest_Today_LineInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Friend_Guest_Today_LineInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_friend_guest_today_line(inputs)
});